<andor-select-field
  [title]="'Language' | translate"
  [options]="options()"
  [selectedOption]="selected()"
  [autoSelectFirst]="false"
  [visibleOptionsCount]="6"
  (selected)="select($event)"
  [toolTipMsg]="
    'The language of the interface. Automatic follows the language settings of your browser.'
      | translate
  ">
  <ng-template #optionIcon let-option>
    <andor-language-flag [language]="flagFor(option.id)" />
  </ng-template>
  <span select-leading class="language-symbol">
    <andor-language-flag [language]="preference()" />
  </span>
</andor-select-field>
